import React from "react"


function ModalLogiciel(params) {


    return(
        <>
        Nous vous proposons d'utiliser un des logiciels suivants :
        <ul>
            <li>
                <a href="https://www.downthemall.net/">DownThemAll!</a>
            </li>
            <li>
                <a href="https://www.freedownloadmanager.org/fr/">Free Download Manager</a>
            </li>
        </ul>


        </>
    )
}

export default ModalLogiciel